// Old or bare addresses that have no page of their own. AllRoutes renders these before
// its /404 catch-all, so bookmarks and old links land on the current page.
export const REDIRECTS = [
  { from: "/teamfeedback", to: "/team-feedback" },
  { from: "/teamfeedback/*", to: "/team-feedback" },
  { from: "/news", to: "/news-app" },
  { from: "/newsandupdate", to: "/news-app" },
  { from: "/newsandupdate/*", to: "/news-app" },
  { from: "/hr/onboarding", to: "/hr/onboarding/my" },
  { from: "/hr/offboarding", to: "/hr/offboarding/my" },
  { from: "/settings/locations", to: "/hr/locations" },
  // Routine is not a legacy product (canon §5.8); its old address must not 404.
  { from: "/routine", to: "/dashboard" },
  { from: "/routine/*", to: "/dashboard" },
];
